
import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribing, setSubscribing] = useState(false);
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubscribing(true);

    const formData = new URLSearchParams();
    formData.append('email', email);

    try {
      const response = await fetch(
        'https://readdy.ai/api/form/d62shopov5qgbon31n0g',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: formData.toString(),
        }
      );

      if (response.ok) {
        setSubscribed(true);
        setEmail('');
        setTimeout(() => setSubscribed(false), 5000);
      } else {
        const errorText = await response.text();
        console.error('Subscription failed:', response.status, errorText);
      }
    } catch (error) {
      console.error('Subscription error:', error);
    } finally {
      setSubscribing(false);
    }
  };

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-stone-300 via-stone-200 to-stone-300 pt-12 md:pt-16 pb-6 px-4 md:px-8 lg:px-12">
      <div className="max-w-7xl mx-auto">
        {/* Main Footer */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-10 md:mb-14">
          {/* Brand */}
          <div className="col-span-1">
            <img
              src="https://static.readdy.ai/image/dadfa7b8e8bbab8ae3e8df395caac6f8/106d52227b4af173f8dda8770a67c446.png"
              alt="SkyForge Industrial Gases"
              className="h-16 md:h-20 mb-4 md:mb-5"
            />
            <p className="text-stone-600 text-sm leading-relaxed mb-4 md:mb-5">
              Delivering precision medical and industrial grade gases to global
              industries since 1987.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="#"
                className="w-10 h-10 bg-stone-100 hover:bg-teal-500 border border-stone-300 hover:border-teal-500 rounded-full flex items-center justify-center transition-all cursor-pointer group shadow-sm"
                rel="nofollow"
              >
                <i className="ri-linkedin-fill text-base text-stone-600 group-hover:text-white"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-stone-100 hover:bg-teal-500 border border-stone-300 hover:border-teal-500 rounded-full flex items-center justify-center transition-all cursor-pointer group shadow-sm"
                rel="nofollow"
              >
                <i className="ri-twitter-x-fill text-base text-stone-600 group-hover:text-white"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-stone-100 hover:bg-teal-500 border border-stone-300 hover:border-teal-500 rounded-full flex items-center justify-center transition-all cursor-pointer group shadow-sm"
                rel="nofollow"
              >
                <i className="ri-youtube-fill text-base text-stone-600 group-hover:text-white"></i>
              </a>
            </div>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-stone-800 font-bold text-sm mb-4 md:mb-5">
              <a href="#products" className="hover:text-teal-600 transition-colors">
                Products
              </a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <button
                  onClick={() => scrollToSection('products')}
                  className="text-stone-600 text-sm hover:text-teal-600 transition-colors cursor-pointer"
                >
                  Medical Oxygen
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('products')}
                  className="text-stone-600 text-sm hover:text-teal-600 transition-colors cursor-pointer"
                >
                  Industrial Nitrogen
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('products')}
                  className="text-stone-600 text-sm hover:text-teal-600 transition-colors cursor-pointer"
                >
                  Specialty Mixtures
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('products')}
                  className="text-stone-600 text-sm hover:text-teal-600 transition-colors cursor-pointer"
                >
                  Calibration Gases
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('products')}
                  className="text-stone-600 text-sm hover:text-teal-600 transition-colors cursor-pointer"
                >
                  Argon Gas
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-stone-800 font-bold text-sm mb-4 md:mb-5">
              <a href="#services" className="hover:text-teal-600 transition-colors">
                Services
              </a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-stone-600 text-sm hover:text-teal-600 transition-colors cursor-pointer"
                >
                  On-Site Delivery
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-stone-600 text-sm hover:text-teal-600 transition-colors cursor-pointer"
                >
                  Equipment Service
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-stone-600 text-sm hover:text-teal-600 transition-colors cursor-pointer"
                >
                  Gas Analysis Lab
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-stone-600 text-sm hover:text-teal-600 transition-colors cursor-pointer"
                >
                  Technical Support
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-stone-600 text-sm hover:text-teal-600 transition-colors cursor-pointer"
                >
                  Emergency Service
                </button>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-stone-800 font-bold text-sm mb-4 md:mb-5">Stay Updated</h4>
            <p className="text-stone-600 text-sm mb-4">
              Get the latest news and industry insights.
            </p>
            <form
              id="newsletter-form"
              data-readdy-form
              onSubmit={handleSubscribe}
              className="space-y-2.5"
            >
              <input
                type="email"
                name="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="w-full bg-stone-100 border border-stone-300 rounded-full px-4 py-2.5 text-stone-800 text-sm focus:outline-none focus:border-teal-400 focus:ring-2 focus:ring-teal-100 transition-all"
              />
              <button
                type="submit"
                disabled={subscribing}
                className="w-full bg-gradient-to-r from-teal-500 to-cyan-500 hover:from-teal-600 hover:to-cyan-600 text-white py-2.5 rounded-full font-semibold text-sm transition-all cursor-pointer whitespace-nowrap disabled:opacity-50 shadow-lg shadow-teal-500/20"
              >
                {subscribing ? 'Subscribing...' : 'Subscribe'}
              </button>
            </form>
            {subscribed && (
              <p className="text-teal-600 text-xs mt-2 font-medium">
                Successfully subscribed!
              </p>
            )}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-stone-400/30 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-stone-500 text-xs text-center md:text-left">
            &copy; 2025 SkyForge Industrial Gases. All rights reserved.
          </p>
          <div className="flex items-center gap-4 md:gap-5 flex-wrap justify-center">
            <a
              href="#"
              className="text-stone-500 text-xs hover:text-stone-700 transition-colors"
            >
              Privacy Policy
            </a>
            <a
              href="#"
              className="text-stone-500 text-xs hover:text-stone-700 transition-colors"
            >
              Terms of Service
            </a>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-stone-500 text-xs hover:text-teal-600 transition-colors"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
